import axios from "axios";
import { canaveral_url, sisi_api_url, valaquenta_api_url } from ".";

export async function fetchTripAdvisorData({ hotel_ids = [] }) {
  try {
    const response = await axios.get(
      `${sisi_api_url}/accommodator/trip-advisor`,
      {
        params: { hotel_ids: hotel_ids.join(",") },
      },
    );
    return response?.data?.results ?? [];
  } catch (error) {
    console.error(error);
  }
  return null;
}

export async function fetchTripAdvisorReviews({
  location_id,
}: {
  location_id: string;
}): Promise<{ [key: string]: any }[] | null> {
  try {
    const response = await axios.get(
      `${sisi_api_url}/accommodator/trip-advisor/reviews/${location_id}`,
    );
    return response?.data ?? [];
  } catch (error) {
    console.error(error);
  }
  return null;
}

export async function rectifyHotelImages({
  img_url,
  hotel_uid,
  supplier = "hotelston",
}: {
  img_url: string;
  hotel_uid: string;
  supplier: string;
}) {
  return await axios.patch(
    `${valaquenta_api_url}/accommodator/hotels-metadata/clean_images/`,
    {
      uid: hotel_uid,
      supplier,
      broken_images: [img_url].filter((i) => i),
    },
  );
}

export const requestCancelReservation = ({
  user_id,
  website_api_key,
  reference,
  reservation_type,
  action_type = "CA",
}: {
  user_id: string;
  website_api_key: string;
  reference: string;
  reservation_type: string;
  action_type: string;
}) => {
  return axios.get(`${canaveral_url}/reservations/alter-request/${reference}`, {
    params: { user_id, website_api_key, reservation_type, action_type },
  });
};

export const cancelReservation = ({
  reference,
  reservation_type = "ACC",
}: {
  reference: string;
  reservation_type?: "ACC";
}) => {
  return axios.patch(`${canaveral_url}/reservations/alter/${reference}`, {
    reservation_type,
    action_type: "CA",
  });
};
